import React from 'react'
import {Link} from 'react-router-dom'
import {Button} from 'semantic-ui-react'
import styled from 'styled-components'


const StyledCard = styled.div.attrs({
    className: 'ui centered card'
})`
  && {
    width: 90%;
    margin-bottom: 15px;
  }
`

export const EventCard = ({event}) => (
    <React.Fragment>
        <StyledCard>
            <div className="ui image">
                <img src={event.feature_image}/>
            </div>
            <div className="content">
                <div>
                    <h1 className="mobile-h1">{event.title}</h1>

                    {event.close_order ? (
                        <Button
                            color="red"
                            className="no-hover"
                            fluid
                            style={{marginTop: '10px'}}
                        >
                            ปิดการสั่งซื้อ
                        </Button>
                    ) : (
                        <Link to={`/events/${event.slug}`}>
                            <Button color="teal" fluid style={{marginTop: '10px'}}>
                                สั่งซื้อ
                            </Button>
                        </Link>
                    )}
                </div>
            </div>
        </StyledCard>
    </React.Fragment>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/EventCard/index.js